import { render, staticRenderFns } from "./GdprBar.vue?vue&type=template&id=25c63dc3&"
import script from "./GdprBar.vue?vue&type=script&lang=js&"
export * from "./GdprBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports